import React from "react";
import { emphasize, styled } from "@mui/material/styles";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Chip from "@mui/material/Chip";
import HomeIcon from "@mui/icons-material/Home";
import { useLocation, Link as RouterLink, useNavigate } from "react-router-dom";

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === "light"
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    "&:hover, &:focus": {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    "&:active": {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
}) as typeof Chip;

type Props = {
  state?: any;
};

const PagesNavigation = ({ state }: Props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathnames = location.pathname.split("/").filter((x) => x);

  const handleBreadcrumbClick = (
    event: React.MouseEvent,
    to: string,
    isSecondToLast: boolean,
    isThirdToLast: boolean
  ) => {
    if (isSecondToLast) {
      event.preventDefault();
      navigate(-1);
    }
    if (isThirdToLast) {
      event.preventDefault();
      navigate(-2);
    }
  };

  return (
    <Breadcrumbs aria-label="breadcrumb">
      <StyledBreadcrumb
        component={RouterLink}
        to="/"
        label=""
        icon={<HomeIcon fontSize="small" />}
        state={state}
      />
      {pathnames.map((value, index) => {
        const last = index === pathnames.length - 1;
        const secondToLast = index === pathnames.length - 2;
        const thirdToLast = index === pathnames.length - 3;
        const to = `/${pathnames.slice(0, index + 1).join("/")}`;
        const decodedValue = decodeURIComponent(value);

        return last ? (
          <StyledBreadcrumb
            key={to}
            component="span"
            label={decodedValue}
          />
        ) : (
          <StyledBreadcrumb
            key={to}
            component={RouterLink}
            to={to}
            label={decodedValue}
            state={state}
            onClick={(event) =>
              handleBreadcrumbClick(event, to, secondToLast, thirdToLast)
            }
          />
        );
      })}
    </Breadcrumbs>
  );
};

export default PagesNavigation;
